import {getMethod} from '@/api'

async function get(params) {
    return await getMethod('/api/printInvoice', params, null, {responseType: 'arraybuffer'})
}

export {get}
